<template>
  <div class="navigation-product">
    <a
      v-for="product of products"
      :key="product.id"
      :href="product.url"
      class="navigation-product__product"
    >
      <div class="navigation-product__product-body">
        <responsive-image
          v-if="product && product.images"
          class="navigation-product__image"
          :image="product.images[0]"
          min-max="300-450"
          ratio="3:2"
        />
        <div class="navigation-product__product-heading-container">
          <h2
            class="
              navigation-product__product-heading
              text-heading-l
              text-heading-m-desktop
            "
            v-text="product.title"
          />

          <product-badge
            v-if="getBadge(product)"
            :text="getBadge(product)"
            :class="productBadgeClass(getBadge(product))"
            text-class="text-heading-s"
          />
        </div>

        <p
          v-if="product.navigationDescription"
          class="navigation-product__product-text text-body-m-regular"
          v-text="product.navigationDescription"
        />

        <product-prices
          class="
            navigation-product__product-price-container
            navigation-product__product-price-mobile product-card__prices
          "
          :class-price="`
            navigation-product__product-price text-heading-s
            ${product?.compareAtPrice?.amount ? 'navigation-product__product-price-varies' : ''}`
          "
          class-compare-at-price="navigation-product__product-compare text-heading-s"
          class-varies="text-body-m-regular"
          :available="product?.available"
          :compare-at-price="product?.compareAtPrice?.amount"
          :price="product?.price?.amount"
          :varies="product?.price?.varies"
          :start-price="product?.price?.min"
        />
      </div>

      <div
        v-if="product.logDiameter || product.boardWidth || product.maxHorsepower"
        class="navigation-product__product-specs"
      >
        <div
          v-if="product.logDiameter"
          class="navigation-product__product-spec"
        >
          <p
            class="navigation-product__product-spec-title text-body-xs-bold"
            v-text="$string('general.site_header.log_diameter')"
          />

          <div class="navigation-product__product-spec-content">
            <p
              class="text-heading-s navigation-product__product-spec-content-text"
              v-text="product.logDiameter"
            />

            <p
              class="navigation-product__product-spec-unit text-body-xs-bold"
              v-text="
                $string('general.site_header.navigation_product_measurement')
              "
            />
          </div>
        </div>

        <div
          v-if="product.widthOfCut"
          class="navigation-product__product-spec"
        >
          <p
            class="navigation-product__product-spec-title text-body-xs-bold"
            v-text="$string('compare.width_of_cut')"
          />

          <div class="navigation-product__product-spec-content">
            <p
              class="text-heading-s"
              v-text="product.widthOfCut"
            />

            <p
              class="navigation-product__product-spec-unit text-body-xs-bold"
              v-text="
                $string('general.site_header.navigation_product_measurement')
              "
            />
          </div>
        </div>

        <div
          v-if="product.maxHorsepower"
          class="navigation-product__product-spec"
        >
          <p
            class="navigation-product__product-spec-title text-body-xs-bold"
            v-text="$string('general.site_header.max_horsepower')"
          />

          <div class="navigation-product__product-spec-content">
            <p
              class="text-heading-s"
              v-text="product.maxHorsepower"
            />

            <p
              class="navigation-product__product-spec-unit text-body-xs-bold"
              v-text="
                $string('general.site_header.navigation_product_power')
              "
            />
          </div>
        </div>
      </div>
      <div class="navigation-product__product-price-desktop">
        <product-prices
          class="
            navigation-product__product-price-container
            navigation-product__product-price product-card__prices
          "
          :class-price="`
            navigation-product__product-price text-heading-s
            ${product?.compareAtPrice?.amount ? 'navigation-product__product-price-varies' : ''}`
          "
          class-compare-at-price="navigation-product__product-compare text-heading-s"
          class-varies="navigation-product__product-varies text-body-xs-bold"
          :available="product?.available"
          :compare-at-price="product?.compareAtPrice?.amount"
          :price="product?.price?.amount"
          :varies="product?.price?.varies"
          :start-price="product?.price?.min"
        />
      </div>
    </a>
  </div>
</template>

<script>

/**
 * Vue: Navigation product (navigation-product)
 * -----------------------------------------------------------------------------
 * Product grid that displays on header navigation & menu drawer.
 *
 */
import ResponsiveImage from '~global/images/responsive-image'
import ProductPrices from '~global/product-prices/product-prices'
import ProductBadge from '~async/product-badge/product-badge'

export default {
  name: 'NavigationProduct',

  components: {
    ResponsiveImage,
    ProductPrices,
    ProductBadge,
  },

  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    getBadge(product) {
      const sale = product.price.amount < product.compareAtPrice.amount
      const badge = product?.tags?.find(tag => tag.toLowerCase().includes('badge'))

      if (!sale && !badge) {
        return false
      }

      return sale ? this.$string('collection.badge.sale') : badge.split(':')[1].trim()
    },

    /**
     * Generate badge class to get proper badge color
     * @param {String} badge - badge name.
     */
    productBadgeClass(badge) {
      const text = badge.replace('_', '-').replace(' ', '-')
      return `product-badge--${text.toLowerCase()}`
    },
  },
}
</script>

<style lang="scss">
@import './navigation-product';
</style>
